import { atom } from "jotai";

type Device = {
    model: string;
    os: string;
    isDarkMode?: boolean;
    language: string;
    deviceId: string;
    countryCd: string;
    inset: {
        statusBarHeight: number;
        navigationBarHeight: number;
    }
}

export const deviceAtom = atom<Device>({
    model: '',
    os: '',
    isDarkMode: undefined,
    language: 'ko',
    deviceId: '',
    countryCd: '',
    inset: {
        statusBarHeight: 0,
        navigationBarHeight: 0
    }
})
